import * as React from 'react';
const SvgElixiaAnniversaryLight = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width={127} height={41} fill="none">
    <path
      fill="#FA5333"
      d="m100.63 28.39-.358-3.835h1.422l.184 2.247 1.705-2.247h1.698l-3.195 3.985-.523 1.84h-1.498l.566-1.99zM106.886 25.87l-.258.883h1.764l-.374 1.314h-1.764l-.292 1h2.479l-.374 1.314h-3.977l1.672-5.824h3.869l-.375 1.315h-2.371zM113.84 24.555v5.824h-1.347v-1.182h-1.889l-.657 1.182h-1.606l3.494-5.824zm-1.347 3.329v-2.063l-1.148 2.063zM118.025 28.124l.882 2.255h-1.564l-.831-2.32-.667 2.32h-1.496l1.663-5.824h2.289c1.14 0 1.747.658 1.747 1.556 0 1.057-.732 1.915-2.022 2.013zm.59-1.87c0-.275-.2-.45-.557-.45h-.907l-.307 1.083h.999c.507 0 .774-.258.774-.632zM119.182 29.548l1.14-.874c.292.332.699.508 1.106.508.507 0 .724-.216.724-.532 0-.225-.166-.39-.432-.615l-.383-.326c-.399-.34-.732-.79-.732-1.372 0-1.04.883-1.897 2.221-1.897 1.007 0 1.673.425 1.938.849l-1.148.866a1.29 1.29 0 0 0-.915-.4c-.374 0-.583.175-.583.458 0 .232.2.407.425.6l.391.332c.383.325.74.782.74 1.347 0 1.115-.766 2.005-2.313 2.005-1.015 0-1.764-.39-2.179-.948z"
    />
    <path
      fill="currentColor"
      d="m112.33 10.57-4.42 3.203c1.782.586 2.752 2.053 2.752 3.834 0 2.616-1.984 5.502-6.089 5.502-3.158 0-4.939-1.67-5.571-3.36l3.248-1.714c.43.902 1.151 1.556 2.323 1.556 1.376 0 2.03-.948 2.03-1.962 0-.743-.428-1.623-1.67-1.623-.405 0-.766.09-1.059.225l-1.354-2.21 4.736-3.452h-5.052l1.082-3.562h10.104zM112.128 18.712c0-4.85 3.383-12.021 9.202-12.021 3.27 0 4.646 1.917 4.646 4.42 0 4.849-3.405 11.998-9.202 11.998-3.271 0-4.646-1.984-4.646-4.397m9.698-6.9c0-.971-.316-1.49-1.196-1.49-2.052 0-4.352 4.963-4.352 7.668 0 .857.202 1.49 1.195 1.49 2.053 0 4.353-4.962 4.353-7.669"
    />
    <path
      fill="#DBDEE0"
      d="M124.754 23.37c-4.286-1.054-4.203-3.184-4.203-3.184l.889-1.343s-.085 2.13 4.202 3.184z"
    />
    <path
      fill="#FA5333"
      d="M98.047 11.83c1.462.61 2.06 1.766 2.06 1.766l-1.047 1.222s-.598-1.154-2.061-1.765zM98.567 5.83c.626-.14 1.094.1 1.094.1l-.06.649s-.468-.242-1.092-.1l.06-.648zM103.905 2.524c.563-.88 1.382-1.137 1.382-1.137l.675.82s-.818.258-1.382 1.139l-.675-.82z"
    />
    <path
      fill="#FF9283"
      d="M107.879 5.77c1.005.664 1.287 1.612 1.287 1.612l-.957.764s-.282-.948-1.287-1.613z"
    />
    <path
      fill="#FA5333"
      d="M113.894 2.234c.188-.907.784-1.378.784-1.378l.817.465s-.596.471-.784 1.378z"
    />
    <path
      fill="#DBDEE0"
      d="M119.723 4.024a2.04 2.04 0 0 1 1.265.267l-.158.751s-.514-.346-1.265-.267z"
    />
    <path
      fill="#FA5333"
      d="M101.184 11.793c.448-.608 1.048-.757 1.048-.757l.449.622s-.602.147-1.048.757z"
    />
    <path
      fill="#FF9283"
      d="M125.153 10.315c.92-.652 1.844-.577 1.844-.577l.343 1.094s-.923-.075-1.844.577z"
    />
    <path
      fill="#FA5333"
      d="M120.52 7.283c.79-.6 1.603-.56 1.603-.56l.332.952s-.812-.04-1.604.559z"
    />
    <path
      fill="#DBDEE0"
      d="M108.223-1.596c.755.59.917 1.36.917 1.36l-.806.544s-.163-.77-.917-1.36z"
    />
    <path
      fill="#FA5333"
      d="M98.7 20.945c-.473-.93-.28-1.764-.28-1.764l1.046-.167s-.193.835.28 1.764z"
    />
    <path
      fill="#C6CDD1"
      d="M103.507 23.826c-.565-1.094-.343-2.08-.343-2.08l1.234-.205s-.222.985.343 2.081z"
    />
    <path
      fill="#DBDEE0"
      d="M108.748 14.542c.622-.67 1.366-.764 1.366-.764l.453.809s-.744.094-1.366.765z"
    />
    <path
      fill="#FF9283"
      d="M114.429 23.434c.328-1.061 1.093-1.556 1.093-1.556l.923.648s-.765.495-1.093 1.557z"
    />
    <path
      fill="currentColor"
      d="m9.94 14.28-1.038 3.524h6.483l-1.21 4.363h-6.57L6.483 26.11h8.816l-1.296 4.363H0L5.964 10h14.002l-1.297 4.363H9.94zM32.585 26.195l-1.297 4.363H17.805l5.964-20.474h5.186l-4.668 16.195h8.298zM40.536 10h5.186l-5.964 20.474h-5.186zM58.514 20.489l3.544 9.985h-5.273l-2.16-6.461-5.618 6.461h-5.964l9.594-10.657L49.093 10h5.272l2.161 6.293L61.971 10h5.964zM71.047 10h5.185L70.27 30.474h-5.186zM93 10v20.474h-4.58v-4.28h-7.002l-2.42 4.28h-5.532L86 10zm-4.58 11.831V13.86l-4.582 7.971z"
    />
  </svg>
);
export default SvgElixiaAnniversaryLight;
